mutation ApprovalCopy($input: ApprovalCopyInput!) {
  approvalCopy(input: $input) {
    clientMutationId
    approval {
      id
      __typename
      _urgencyLevel
      description
      name
      _fullApprovalDescription
      isAddApproversEligible
      isPrimary
      isNewApprovalSelectable
      isDelayedApproverAllowed
      isNewProjectIncluded
      _rowTimestamp
      _isDeletable
      approvalType {
        id
        approvalType
        layoutType
      }
      approvalPhaseTypeId
      approvalPhaseType {
        id
        phaseName
      }
      _createdDate
      priorityNumber
      abbreviation
      isDraft
      _statusTypeId
      statusType {
        approvalState
        statusType
        _transactionIconStatus
      }
      _isStagedApprovalRequest
    }
  }
}
